/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthHistoryDto } from '../../models/growth-history-dto';

export interface GrowthHistoryControllerFindById$Params {
  id: string;
}

export function growthHistoryControllerFindById(http: HttpClient, rootUrl: string, params: GrowthHistoryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthHistoryDto>> {
  const rb = new RequestBuilder(rootUrl, growthHistoryControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrowthHistoryDto>;
    })
  );
}

growthHistoryControllerFindById.PATH = '/api/growth-history/{id}';
